export default "__VITE_ASSET__ToN53Kuq__"